import { Link } from '@superops/ui-design-system';
import {
  User,
  Store,
  MapMarkerAlt,
  CalendarCheck,
  Medal
} from '@styled-icons/fa-solid';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import {
  DetailHolder,
  DueHolder,
  StatusHolder,
  TaskProgressHolder,
  MilestoneHolder
} from '@nile/projects/src/Components/Elements';
import envConfig from '@nile/home/src/Config/env';
import { useMutation } from '@apollo/client';
import {
  HARD_DELETE_PROJECTS,
  SOFT_DELETE_PROJECTS,
  RESTORE_PROJECTS
} from '@nile/projects/src/Graphql';
import {
  getTranslatedText,
  Icon,
  BackgroundIcon,
  toast,
  DeleteModal,
  actionToast,
  ALL_MODULES,
  Tag,
  COLOR_MAP,
  AccessControl
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';

const OuterWrapper = styled.div`

  .actionButtons{
    visibility: hidden;
  }
  .danger {
    color: #e02020;
  }
  &:hover{
    .actionButtons{
      visibility: visible;
      transition: all 0.2s ease;
    }
  }
  /* opacity: ${(props) => (props.isDeleted ? '0.5' : '1')}; */
  .task-progress{
    display: flex;
    flex: 0 0 30%;
  }
`;

const ProjectTitle = styled.div`
  font-weight: 500;
  font-size: 2rem;
  line-height: 3rem;
`;

export const PROJECT_STATUSES = {
  ACTIVE: ['Completed'],
  NORMAL: ['Planned', 'In Progress'],
  INACTIVE: ['Cancelled', 'Blocked', 'Deleted']
};

const ProjectListItem = (props) => {
  const { intl, allowDelete, accountType, updateList } = props;
  const ticketContext = useContext(TicketContext);

  const [hardDeleteProjects] = useMutation(HARD_DELETE_PROJECTS, {
    onCompleted({ hardDeleteProjects }) {
      if (hardDeleteProjects) {
        toast('success', 'toast.projects.harddelete.success');
        updateList();
      }
    }
  });

  const [softDeleteProjects] = useMutation(SOFT_DELETE_PROJECTS, {
    onCompleted({ softDeleteProjects }) {
      if (softDeleteProjects) {
        // toast('success', 'toast.projects.softdelete.success');
        updateList();
      }
    }
  });

  const [restoreProjects] = useMutation(RESTORE_PROJECTS, {
    onCompleted({ restoreProjects }) {
      if (restoreProjects) {
        toast('success', 'toast.projects.restore.success');
        updateList();
      }
    }
  });

  const handleRestore = (id) => {
    restoreProjects({ variables: { ids: [id] } });
  };

  const handlePermanentDelete = (id) => {
    hardDeleteProjects({ variables: { ids: [id] } });
  };

  const handleSoftDelete = (id) => {
    softDeleteProjects({ variables: { ids: [id] } }).then((res) =>
      actionToast('info', 'toast.projects.softdelete.success', {
        title: 'project.view.undo.button',
        action: () => handleRestore(id)
      })
    );
  };

  return (
    <OuterWrapper isDeleted={props.detail?.status === 'Deleted'}>
      <div className="box-with-border m8">
        <div className="flex actr">
          <div className="f11">
            <div className="fx fx-sb  actr mb-20" data-qa="projectTitle">
              <div className="flex actr">
                {allowDelete ? (
                  <ProjectTitle>{props.detail.title}</ProjectTitle>
                ) : (
                  <Link
                    onClick={() => {
                      props.history.push(
                        `#/project/${props.detail.projectId}/detail`
                      );
                    }}
                    // url={`#/project/${props.detail.projectId}/detail`}
                    removeUnderline
                  >
                    <ProjectTitle
                      onClick={() => {
                        ticketContext.openTab({
                          module: ALL_MODULES.projectDetail,
                          data: {
                            projectId: props.detail.projectId,
                            title: props.detail.title
                          }
                        });
                        console.log('creating');
                      }}
                    >
                      {props.detail.title}
                    </ProjectTitle>
                  </Link>
                )}
                <Tag
                  className="uppercase ml-10"
                  active={PROJECT_STATUSES.ACTIVE.includes(props.detail.status)}
                  smooth={PROJECT_STATUSES.NORMAL.includes(props.detail.status)}
                >
                  {props.detail.status}
                </Tag>
              </div>
            </div>
            <div className="flex actr">
              <AccessControl
                productToCheck="MSP"
                render={
                  <>
                    {accountType !== 'CLIENT' && (
                      <DetailHolder
                        title={getTranslatedText(intl, 'project.view.client')}
                        icon="ClientLogo"
                        value={props.detail.client?.name || 'NA'}
                      />
                    )}
                    <DetailHolder
                      title={getTranslatedText(intl, 'project.view.site')}
                      icon="Site"
                      value={props.detail.site?.name || 'NA'}
                    />
                  </>
                }
              />
              <DetailHolder
                title={getTranslatedText(intl, 'project.view.owner')}
                avatar
                value={props.detail.owner?.name || 'NA'}
              />
              <DueHolder
                title={getTranslatedText(intl, 'project.view.dueDate')}
                icon="DatePicker"
                start={props.detail.scheduledStartDate}
                dueDate={props.detail.dueDate}
                overdue={props.detail.overdue}
                actualEndDate={props.detail.actualEndDate}
              />
              <MilestoneHolder
                title={getTranslatedText(intl, 'project.view.milestone')}
                icon="Milestone"
                completed={props.detail.completedMilestones}
                total={props.detail.totalMilestones}
              />
            </div>
          </div>
          <div className="ml-20 task-progress">
            <TaskProgressHolder
              completed={props.detail.completedTasks}
              total={props.detail.totalTasks}
              overdue={props.detail.overdueTasks}
              open={props.detail.plannedTasks}
              progress={props.detail.inProgressTasks}
              blocked={props.detail.blockedTasks}
            />
          </div>
        </div>
      </div>
    </OuterWrapper>
  );
};

export default withRouter(injectIntl(ProjectListItem));
